import script from "./FileController.vue?vue&type=script&setup=true&lang=js"
export * from "./FileController.vue?vue&type=script&setup=true&lang=js"

import "./FileController.vue?vue&type=style&index=0&id=1875cd18&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1875cd18"]])

export default __exports__